import React, { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import messages from './messages';

export const DeliveryTimeDropdownOption = ({ maxTransitDays, onMaxTransitDaysChangeComplete }) => {
  const onClick = useCallback(
    () => onMaxTransitDaysChangeComplete(maxTransitDays, false),
    [maxTransitDays, onMaxTransitDaysChangeComplete],
  );
  return (
    <DropdownMenuItem onClick={onClick}>
      <FormattedMessage {...messages.deliveryTimeWithDayValueIncluded} values={{ days: maxTransitDays }} />
    </DropdownMenuItem>
  );
};
